<script setup lang="ts">
import { computed } from 'vue'

export type StepIconListItem = {
  id: string
  name: string
  imageUpload?: { imageUrl: string } | null
}

const props = defineProps<{
  icons: StepIconListItem[]
  size?: number
  compact?: boolean
  tooltipTitle?: string
}>()

defineOptions({ inheritAttrs: false })

const sizeStyle = computed(() => (props.size ? { '--step-icon-size': `${props.size}px` } : {}))
</script>

<template>
  <template v-if="props.icons.length > 0">
    <template v-if="props.compact">
      <span v-bind="$attrs" class="step-icon-list step-icon-list--compact" :style="sizeStyle">
        <img
          v-for="icon in props.icons"
          :key="icon.id"
          :src="icon.imageUpload?.imageUrl"
          :alt="icon.name"
          class="step-icon"
        />
      </span>
      <v-tooltip activator="parent" location="bottom">
        <div v-if="props.tooltipTitle" class="step-icon-tooltip-title">
          {{ props.tooltipTitle }}
        </div>
        <div v-for="icon in props.icons" :key="icon.id" class="step-icon-tooltip-row">
          <img :src="icon.imageUpload?.imageUrl" alt="" class="step-icon-tooltip-image" />
          {{ icon.name }}
        </div>
      </v-tooltip>
    </template>

    <span v-else v-bind="$attrs" class="step-icon-list" :style="sizeStyle">
      <v-tooltip v-for="icon in props.icons" :key="icon.id" :text="icon.name" location="bottom">
        <template #activator="{ props: tooltipProps }">
          <img
            v-bind="tooltipProps"
            :src="icon.imageUpload?.imageUrl"
            :alt="icon.name"
            class="step-icon"
          />
        </template>
      </v-tooltip>
    </span>
  </template>
</template>

<style scoped lang="scss">
.step-icon-list {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: calc(var(--step-icon-size, 40px) / 5);
  vertical-align: middle;
}
.step-icon-list--compact {
  display: inline;

  .step-icon {
    display: inline-block;
    vertical-align: middle;
    margin-left: calc(var(--step-icon-size, 40px) / 5);
  }
}
.step-icon {
  display: block;
  flex-shrink: 0;
  width: var(--step-icon-size, 40px);
  height: var(--step-icon-size, 40px);
  object-fit: contain;
}
.step-icon-tooltip-title {
  font-weight: 500;
  margin-bottom: 4px;
}
.step-icon-tooltip-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 0;
}
.step-icon-tooltip-image {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
</style>
